import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PencilLineIcon} from '@/components/ui/icon/Icon'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useTranslation} from '@/translations/i18n'

interface EditDetailsSectionButtonsProps {
    isActive: boolean
    isLoading?: boolean
    isDisabled?: boolean
    onConfirm?: () => void
    onCancel: () => void
    onEdit?: () => void
}

export const EditDetailsSectionButtons = ({
    isActive,
    isLoading,
    isDisabled,
    onConfirm,
    onCancel,
    onEdit
}: EditDetailsSectionButtonsProps) => {
    const {t} = useTranslation()

    if (isActive) {
        return (
            <Flexbox align="center" gap={2}>
                <Button variant="ghost" disabled={isLoading} onClick={onCancel}>
                    {t('commons:cancel')}
                </Button>
                <Button variant="primaryNeutral" disabled={isDisabled || isLoading} onClick={onConfirm}>
                    {isLoading && <Spinner />}
                    {t('commons:confirm')}
                </Button>
            </Flexbox>
        )
    }

    return (
        <>
            {!!onEdit && (
                <Button variant="ghost" onClick={onEdit} disabled={isDisabled}>
                    <PencilLineIcon />
                    {t('commons:edit')}
                </Button>
            )}
        </>
    )
}
